/* eslint-disable indent */
/* eslint-disable no-unused-vars */

const isObj = require('lodash.get');

export const getAllStoryPhone = (state) => isObj(state, 'storyPhone', []);
export const getStoryPhoneById = (state) => isObj(state, 'storyPhoneById', []);
export const getDeletedStoryPhone = (state) => isObj(state, 'deletedStoryPhone', []);
export const getstoryPhoneModels = (state) => isObj(state, 'storyPhoneModels', []);
